(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  initPromoVidPopup();
});
function initPromoVidPopup() {
  var promoOpenBtn = document.querySelector('#open-partner-promo');
  if (!promoOpenBtn) return;
  var promoPopupContent = document.querySelector('.partner-promo-popup-content').innerHTML;
  var modal = new tingle.modal({
    closeMethods: ['overlay', 'button', 'escape'],
    closeLabel: 'Close',
    cssClass: ['itt-modal'],
    onOpen: function onOpen() {
      var iframe = modal.modal.querySelector('iframe');
      if (iframe) {
        iframe.setAttribute('src', iframe.getAttribute('data-src'));
      }
    },
    onClose: function onClose() {
      var iframe = modal.modal.querySelector('iframe');
      var video = modal.modal.querySelector('video');
      if (iframe) {
        iframe.setAttribute('src', '');
      } else if (video) {
        video.pause();
      }
    }
  });
  modal.setContent(promoPopupContent);
  promoOpenBtn.addEventListener('click', function (e) {
    e.preventDefault();
    modal.open();
  });
}

},{}]},{},[1]);
